var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"receivables-aging","route":"/reports/billing-receivables-aging","file-name":"contas-a-receber-de-convenio.xlsx","period-label":"Período de emissão do título","columns":_vm.columns,"default-days":180}})
}
var staticRenderFns = []

export { render, staticRenderFns }